'use client';

import { Button } from '@/components/ui/button';
import { useRouter } from 'next/navigation';
import { FileQuestion } from 'lucide-react';

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] gap-6">
      <FileQuestion className="w-16 h-16 text-muted-foreground" />
      <h1 className="text-2xl font-semibold text-foreground">Page Not Found</h1>
      <p className="text-muted-foreground text-sm">The page you&apos;re looking for doesn&apos;t exist or has been moved.</p>
      <div className="flex gap-3">
        <Button variant="outline" onClick={() => router.back()}>
          Go Back
        </Button>
        <Button variant="brandPrimary" onClick={() => router.push('/')}>
          Go to Dashboard
        </Button>
      </div>
    </div>
  );
}
